import{useContext as e,useLayoutEffect as n}from"react";const t=(t,r,d)=>{const{registerDescendant:s,descendants:c}=e(r),i=d??c.findIndex((e=>e.element===t.element));return n((()=>{if(t.element)return s({...t,index:i})}),[t,i,s]),i};export{t as useDescendantsContext};
//# sourceMappingURL=useDescendantsContext.js.map
